import styled from 'styled-components';
import { RowFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';

export const Indicator = styled(RowFlexContainer)`
  & > div {
    width: ${({ theme: { spacing } }) => spacing(12)};
    word-wrap: break-word;
  }
`;
